module.exports = __webpack_public_path__ + "app/principal/principal-import-iHGUwWg4.html";